import React from 'react';
import { PricingTemplate } from '../../../types/contractor';
import {
    Card,
    CardContent,
    List,
    ListItem,
    ListItemText,
    Typography,
} from '@mui/material';

interface PricingTemplatePreviewProps {
    template: PricingTemplate;
    index?: number;
}

const PricingTemplatePreview = ({ template }: PricingTemplatePreviewProps) => {
    return (
        <Card variant='outlined' sx={{ mt: 2 }}>
            <CardContent>
                <Typography sx={{ fontWeight: 'bold' }}>
                    {template.order + 1}: {template.name}
                </Typography>
                <List>
                    {template.items.map((item) => (
                        <ListItem key={item.id} divider>
                            <ListItemText
                                primary={item.name}
                                secondary={item.description}
                                secondaryTypographyProps={{
                                    whiteSpace: 'pre-wrap',
                                }}
                            />
                            <Typography>${item.cost} (ex. GST)</Typography>
                        </ListItem>
                    ))}
                </List>
            </CardContent>
        </Card>
    );
};

export default PricingTemplatePreview;
